export default __webpack_public_path__ + "static/media/reactnative.9f360a83.svg";